var map = {
	"./calendar.svg": "9da0",
	"./careclub.svg": "d980",
	"./connection-hub.svg": "a04a",
	"./dashboard.svg": "e752",
	"./document-center.svg": "b883",
	"./health-record.svg": "0047",
	"./insurance.svg": "e38d",
	"./journal.svg": "9601"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2b50";